import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0756f9c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col-12 col-xl-9 mb-6 mb-xl-0" }
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = { class: "col-12 col-lg-8" }
const _hoisted_6 = { class: "border-top border-dark mt-5 py-3" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("  |  ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "row"
}
const _hoisted_12 = { class: "col-12 col-lg-8" }
const _hoisted_13 = { class: "border-top border-dark mt-5 py-3" }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode("  |  ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = ["data-tooltip"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LuLeftMenu = _resolveComponent("LuLeftMenu")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(["main", { 'mt-2': _ctx.compact }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.leftmenu)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_LuLeftMenu, { menu: _ctx.leftmenu }, null, 8, ["menu"]),
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true),
              (_ctx.pageManagerMail)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createTextVNode(_toDisplayString(_ctx.$t("main.page-manager")) + ": ", 1),
                        _createElementVNode("a", {
                          href: `mailto:${_ctx.pageManagerMail}`
                        }, _toDisplayString(_ctx.pageManagerMail), 9, _hoisted_7),
                        _hoisted_8,
                        _createElementVNode("strong", null, _toDisplayString(_ctx.lastUpdated), 1),
                        (_ctx.pageManagerNotice)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_9,
                              _createElementVNode("small", null, _toDisplayString(_ctx.pageManagerNotice), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true),
            (_ctx.pageManagerMail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createTextVNode(_toDisplayString(_ctx.$t("main.page-manager")) + ": ", 1),
                      _createElementVNode("a", {
                        href: `mailto:${_ctx.pageManagerMail}`
                      }, _toDisplayString(_ctx.pageManagerMail), 9, _hoisted_14),
                      _hoisted_15,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.lastUpdated), 1),
                      (_ctx.pageManagerNotice)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_16,
                            _createElementVNode("small", null, _toDisplayString(_ctx.pageManagerNotice), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          id: "toTopButton",
          onfocus: "this.blur()",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args))),
          "data-tooltip": _ctx.toTopText
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "arrow-circle-up" })
        ], 8, _hoisted_17)
      ])
    ])
  ], 2))
}